import { render, staticRenderFns } from "./PhotoDeleteDialog.vue?vue&type=template&id=42749985&scoped=true&"
import script from "./PhotoDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./PhotoDeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./PhotoDeleteDialog.vue?vue&type=style&index=0&id=42749985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42749985",
  null
  
)

export default component.exports